import zipObject from 'lodash-es/zipObject'

import { EMPTY_LIST } from '../../../../../constants/common'
import { PAGE_DEFAULT_VALUE } from '../../../../../constants/route'
import { toOrderingList } from '../../../../../utils/sort'
import {
  APPLICANT_BOARD_COLUMN_CAP,
  APPLICANT_BOARD_COLUMN_ORDER,
} from '../../RentalPortalApplicants.constants'

export function getApplicantsBoardStages(filterValues) {
  const filteredStages = filterValues?.stage ?? EMPTY_LIST

  return filteredStages.length > 0
    ? APPLICANT_BOARD_COLUMN_ORDER.filter(stage =>
        filteredStages.includes(stage)
      )
    : APPLICANT_BOARD_COLUMN_ORDER
}

export function getApplicantsBoardColumnBody({
  filterValues,
  ordering,
  stage,
}) {
  return {
    filters: { ...filterValues, stage: [stage] },
    ordering: toOrderingList(ordering),
    page: PAGE_DEFAULT_VALUE,
    size: APPLICANT_BOARD_COLUMN_CAP,
  }
}

export function getApplicantsBoardReadKey({ filterValues, ordering }) {
  return JSON.stringify([filterValues, ordering])
}

export function toApplicantsBoardColumns({ responses, stages }) {
  return zipObject(
    stages,
    responses.map(({ data: { items, pagination } }) => ({
      items,
      total: pagination.total,
    }))
  )
}

export function getIsApplicantsBoardRefetching({ refetchGeneration, result }) {
  return refetchGeneration > (result?.generation ?? 0)
}
